<script setup>
import {ref, defineProps} from "vue";

const props = defineProps({
    content: Object
});

const isPlaying = ref(false);

const handlePlay = () => {
    isPlaying.value = true;
};

const handlePause = () => {
    isPlaying.value = false;
};
</script>
<template>
    <div
        class="flex flex-col items-center space-y-6 bg-gray-200 p-10 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
        <div class="group relative flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                 stroke="currentColor"
                 :class="['h-16 w-16 transition-transform duration-200 ease-in-out transform', {'scale-110 text-purple-500 rotate-animation': isPlaying}]">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
            </svg>
            <div class="py-3 text-blue-900 text-lg font-semibold">{{ props.content.name }}</div>
        </div>
        <audio ref="player" controls class="rounded-md mt-4" v-bind:src="props.content.value" @play="handlePlay"
               @pause="handlePause">
        </audio>
    </div>
</template>

<style scoped>
/* Your scoped styles here */
.relative {
    position: relative;
}

.rotate-animation {
    animation: rotation 2s infinite linear;
}

@keyframes rotation {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}
</style>
